module.exports = __webpack_public_path__ + "img/bg.c888fe04.jpg";